"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyWordFlashcardTypeSchema = exports.WordToAnyFlashcardTypeSchema = exports.PicToWordFlashcardTypeSchema = void 0;
const zod_1 = require("zod");
exports.PicToWordFlashcardTypeSchema = zod_1.z.literal("PIC_TO_WORD");
exports.WordToAnyFlashcardTypeSchema = zod_1.z.literal("WORD_TO_ANY");
exports.AnyWordFlashcardTypeSchema = zod_1.z.union([
    exports.PicToWordFlashcardTypeSchema,
    exports.WordToAnyFlashcardTypeSchema,
]);
//# sourceMappingURL=word_flashcard_type_types.js.map